import { getUrl } from '../utils/getUrl';
import { headers } from './account';

interface GetEntriesType {
  handle: string;
  filter?: string;
  since?: string;
  sources?: string | string[];
  amount?: number;
}

export const getEntries = async ({
  handle,
  filter,
  since,
  sources,
  amount,
}: GetEntriesType) => {
  let filterPath = !filter ? '' : `/filter/${filter}`;
  let dateParam = !since ? '' : `?filterDate=${since}`;
  let sourcesParam = !sources ? '' : `${since ? '&' : '?'}handles=${sources}`;
  let amountParam = !amount
    ? ''
    : `${since || sources ? '&' : '?'}amount=${amount}`;

  return fetch(
    `${getUrl()}/api/account/${handle}/source/entry${filterPath}${dateParam}${sourcesParam}${amountParam}`,
    { headers }
  ).then((res) => res.json());
};

export const getEntry = (handle, postId) =>
  fetch(`${getUrl()}/api/account/${handle}/source/entry/${postId}`, {
    headers,
  }).then((res) => res.json());

export const getMixedStream = async (handles: string[], since?: string) => {
  let dateParam = !since ? '' : `&filterDate=${since}`;
  return fetch(
    `${getUrl()}/api/account/source/entry?handles=${handles}${dateParam}`,
    { headers }
  ).then((res) => res.json());
};
